import ReactGA from 'react-ga4'

const useAnalyticsEventTracker = (category= "Home") => {
	return (action = "action", label = "label", ...props: any[]) => {
		ReactGA.event({ category, action, label, ...props });
	};
}
export default useAnalyticsEventTracker;
